import { useCallback, useEffect } from "react";
import api from "../../../utils/api/axiosInstance";
import { useUserAuth } from "../../../contexts/UserAuthContext";
import usePlatformEvents from "../../../hooks/usePlatformEvents";

const useProductInteractionTracking = ({ productId, trackView }) => {
  const { user } = useUserAuth();
  const { trackProduct } = usePlatformEvents();

  const trackInteraction = useCallback(
    (action) => {
      if (!productId) return;

      if (user) {
        trackProduct(action, productId, { surface: "pdp" });
        return;
      }

      const sessionId = localStorage.getItem("currentSessionId");
      if (sessionId) {
        Promise.resolve(
          api.post("/analytics/interaction", {
            sessionId,
            productId,
            action,
          }),
        ).catch(() => {});
      }
    },
    [productId, user, trackProduct],
  );

  useEffect(() => {
    if (!productId) return;

    if (user) {
      trackProduct("view", productId, { surface: "pdp" });
    } else {
      const sessionId = localStorage.getItem("currentSessionId");
      if (sessionId) {
        Promise.resolve(
          api.post("/analytics/interaction", {
            sessionId,
            productId,
            action: "view",
          }),
        ).catch(() => {});
      }
    }

    trackView(productId);
  }, [productId, trackView, trackProduct, user]);

  return { trackInteraction };
};

export default useProductInteractionTracking;
